import React from 'react'
import { Spinner } from 'reactstrap'

export default ({ color, ...rest }) => (
  <Spinner
    color={color || 'interactive'}
    style={{ width: '40px', height: '40px', borderWidth: 3 }}
    {...rest}
  />
)
